module.exports = __webpack_public_path__ + "static/media/desktop_blue.3214bfd3.svg";